/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { CHALLENGES: de },
  'el-GR': { CHALLENGES: el },
  'en-US': { CHALLENGES: en },
  'es-ES': { CHALLENGES: es },
  'fi-FI': { CHALLENGES: fi },
  'fr-FR': { CHALLENGES: fr },
  'it-IT': { CHALLENGES: it },
  'pl-PL': { CHALLENGES: pl },
  'pt-PT': { CHALLENGES: pt }
};
